import { CustomRuleGroup, Filter } from '../../models/filter-models';
import {
  isCustomRuleGroupsEnabled,
  nextCustomRuleGroupName,
  setCustomRuleGroupsEnabled,
  shouldShowEnableCustomRuleGroupsLink,
} from './custom-rule-groups-helper';
import { isCustomRuleLabelsEnabled, setCustomRuleLabelsEnabled } from './custom-rule-labels-helper';
import { CustomRuleGroupsReorderController } from './custom-rule-groups-reorder.controller';

export class CustomRuleGroupsTabController {
  enableCustomRuleGroups = false;
  showEnableCustomRuleGroupsLink = false;
  enableCustomRuleLabels = false;

  readonly ruleReorder: CustomRuleGroupsReorderController;

  constructor(
    private readonly getGroups: () => CustomRuleGroup[],
    private readonly getFilter: () => Filter,
    private readonly onUpdate: () => void,
    private readonly newGroupNamePrefix: string,
  ) {
    this.ruleReorder = new CustomRuleGroupsReorderController(getGroups, onUpdate);
  }

  refreshUiState(): void {
    const groups = this.getGroups();
    if (groups) {
      this.enableCustomRuleGroups = isCustomRuleGroupsEnabled(groups);
      this.showEnableCustomRuleGroupsLink = shouldShowEnableCustomRuleGroupsLink(groups);
    }
    const f = this.getFilter();
    if (f) {
      this.enableCustomRuleLabels = isCustomRuleLabelsEnabled(f);
    }
    this.ruleReorder.invalidateGroups();
  }

  enableFromLink(ev: Event): void {
    ev.preventDefault();
    setCustomRuleGroupsEnabled(true);
    setCustomRuleLabelsEnabled(true);
    this.refreshUiState();
  }

  addGroup(): void {
    const groups = this.getGroups();
    const name = nextCustomRuleGroupName(this.newGroupNamePrefix, groups);
    const order = groups.length === 0 ? 0 : Math.max(...groups.map(g => g.order)) + 1;
    groups.push(new CustomRuleGroup({ name, isDefault: false, active: true, order, rules: [] }));
    this.refreshUiState();
    this.onUpdate();
  }

  removeGroup(group: CustomRuleGroup): void {
    const groups = this.getGroups();
    const idx = groups.indexOf(group);
    if (idx >= 0) groups.splice(idx, 1);
    this.refreshUiState();
    this.onUpdate();
  }

  updateFilter(): void {
    this.refreshUiState();
    this.onUpdate();
  }
}
